import axios from "axios";
import Cookies from "js-cookie";

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const authToken = Cookies.get("authToken");
  if (authToken) {
    config.headers["Authorization"] = `Bearer ${authToken}`;
  }

  // Add Accept-Language header based on stored language preference
  const currentLanguage = localStorage.getItem("lang") || "en";
  config.headers["Accept-Language"] = currentLanguage;

  return config;
});

export default apiClient;
